// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import formStyles from './Form.module.css';

function Alert({ message, children = null, theme = {}, type = 'error' }) {
  if (!message && !children) {
    return null;
  }

  const cssClass = `${type}Alert`;
  return (
    <div
      className={
        theme[cssClass] || formStyles[cssClass] || formStyles.infoAlert
      }
    >
      {message || children}
    </div>
  );
}

export default Alert;
